import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhom() {
  const idealFor = ['Mujeres en EE.UU. que quieren un ingreso extra desde casa', 'Principiantes que necesitan un paso a paso sin confusión', 'Quienes prefieren leer e imprimir, no ver videos', 'Emprendedoras que quieren vender en Facebook o Shopify'];
  const notFor = ['No es para ti si buscas videos, kit físico o clases en vivo'];
  return <section className="bg-brand-bg py-14" data-id="element-57">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center text-brand-text" data-id="element-60">
            PARA QUIÉN ES
          </h2>

          <div className="bg-white rounded-3xl shadow-sm border border-brand-line/20 p-8 md:p-10" data-id="element-61">
            <ul className="space-y-6 mb-10" data-id="element-62">
              {idealFor.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="flex items-start gap-4" data-id="element-63">
                  <div className="mt-1 bg-green-100 text-green-700 rounded-full p-1 flex-shrink-0" data-id="element-64">
                    <Check className="w-5 h-5" strokeWidth={3} data-id="element-65" />
                  </div>
                  <span className="text-lg text-brand-text" data-id="element-66">{item}</span>
                </motion.li>)}
            </ul>

            <div className="h-px w-full bg-brand-line/30 mb-8" data-id="element-67"></div>

            <ul className="space-y-4" data-id="element-68">
              {notFor.map((item, i) => <li key={i} className="flex items-start gap-4 opacity-70" data-id="element-69">
                  <div className="mt-1 bg-red-100 text-red-700 rounded-full p-1 flex-shrink-0" data-id="element-70">
                    <X className="w-5 h-5" strokeWidth={3} data-id="element-71" />
                  </div>
                  <span className="text-lg text-brand-text" data-id="element-72">{item}</span>
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}